var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tbody', [!_vm.rows2.records || _vm.rows2.records.length < 1 ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._e(), _vm._l(_vm.rows2.records, function (row, index) {
    var _row$agent_code;

    return _c('tr', {
      key: index
    }, [_c('td', [_c('span', {
      staticClass: "agent-info"
    }, [_vm._v(_vm._s(row.agent_name) + " (" + _vm._s((_row$agent_code = row.agent_code) !== null && _row$agent_code !== void 0 ? _row$agent_code : '') + ")")])]), _c('td', [_c('span', {
      staticClass: "special-way"
    }, [_vm._v("$" + _vm._s(row.special_commisssion))]), row.special_commisssion > 0 || row.special_pdf_link !== null ? _c('div', [_c('div', {
      staticClass: "action-icons"
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": row.special_pdf_link,
        "title": "Download PDF",
        "download": "",
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-file-pdf"
    })]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": row.special_csv_link,
        "title": "Download CSV",
        "download": "",
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-file-csv"
    })])])]) : _vm._e()]), _c('td', [_c('span', {
      staticClass: "one-time"
    }, [_vm._v("$" + _vm._s(row.onetime_commmission))]), row.onetime_commisssion > 0 || row.onetime_pdf_link !== null ? _c('div', [_c('div', {
      staticClass: "action-icons"
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": row.onetime_pdf_link,
        "title": "Download PDF",
        "download": "",
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-file-pdf"
    })]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": row.onetime_csv_link,
        "title": "Download CSV",
        "download": "",
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-file-csv"
    })])])]) : _vm._e()]), _c('td', [_c('span', {
      staticClass: "association"
    }, [_vm._v("$" + _vm._s(row.association_commmission))]), row.association_commmission > 0 || row.association_pdf_link !== null ? _c('div', [_c('div', {
      staticClass: "action-icons"
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": row.association_pdf_link,
        "title": "Download PDF",
        "download": "",
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-file-pdf"
    })]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": row.association_csv_link,
        "title": "Download CSV",
        "download": "",
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-file-csv"
    })])])]) : _vm._e()]), _c('td', [_c('span', {
      staticClass: "overall-amount"
    }, [_vm._v("$" + _vm._s(row.other_comm_total))])]), _c('td', [_c('span', {
      staticClass: "month-year"
    }, [_vm._v(_vm._s(row.date))])]), _c('td', [_c('span', {
      staticClass: "payment-status"
    }, [_vm._v(_vm._s(row.payment_status.toUpperCase()))])])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }